// Traduções — Português (idioma de referência e fallback). Chave = texto usado no t() (ver src/i18n.js).
const pt = {
  'Welcome back': 'Bem vindo(a)',
  'Yes': 'Sim',
  'No': 'Não',
  'Dashboard': 'Painel de Controle',
  "We've missed you": 'Tenha um ótimo dia.',
  'Users': 'Usuários',
  'User': 'Usuário',
  'user': 'usuário',
  'judge': 'jurado',
  'producer': 'produtor',
  'Edit User': 'Editar Usuário',
  'Edit Producer': 'Editar Produtor',
  'Edit Judge': 'Editar Jurado',
  'Add User': 'Adicionar Usuário',
  'Add Producer': 'Adicionar Produtor',
  'Add Judge': 'Adicionar Jurado',
  'Name': 'Nome',
  'Full Name': 'Nome Completo',
  'Lastname': 'Sobrenome',
  'E-mail': 'E-mail',
  'Language': 'Idioma',
  'Languages': 'Idiomas',
  'Role': 'Função',
  'Actions': 'Ações',
  'New User': 'Novo Usuário',
  'Save': 'Salvar',
  'Save Changes': 'Salvar Alterações',
  'Producer': 'Produtor',
  'Judge': 'Jurado',
  'Admin': 'Administrador',
  'Password': 'Senha',
  'Confirm Password': 'Confirmar Senha',
  'Portuguese': 'Português',
  'English': 'Inglês',
  'Spanish': 'Espanhol',
  'Italian': 'Italiano',
  'French': 'Francês',
  'Close': 'Fechar',
  'Occured an Error': 'Ocorreu um erro',
  'Done': 'Concluir',
  'User registred successfully': 'Usuário cadastrado com sucesso',
  'Required field': 'O campo é obrigatório',
  'User updated successfully': 'Usuário atualizado com sucesso',
  'Product registered successfully': 'Produto inscrito com sucesso',
  'Registration updated successfully': 'Inscrição atualizado com sucesso',
  "Farm's Name": 'Nome da Fazenda / Queijaria',
  "Farm's Legal Representative": 'Representante Legal da Fazenda',
  'Country': 'País',
  'State': 'Estado',
  'Status': 'Status',
  'Active': 'Ativo',
  'Inactive': 'Inativo',
  'Producers': 'Produtores',
  'Judges': 'Jurados',
  'Website': 'Site',
  'Phone Number': 'Telefone Fixo',
  'Cellphone Number': 'Celular',
  'Document Number': 'Número do Documento',
  'RG': 'RG',
  'CPF': 'CPF',
  'CNPJ': 'CNPJ',
  'Passport': 'Passaporte',
  'ID Document Type': 'Tipo de Documento de Identificação',
  'City': 'Cidade',
  'Zip-Code': 'CEP',
  'Producer updated successfully': 'Produtor alterado com sucesso',
  'Judge updated successfully': 'Jurado alterado com sucesso',
  'Producer registered successfully': 'Produtor cadastrado com sucesso',
  'Judge registered successfully': 'Jurado cadastrado com sucesso',
  'Curator updated successfully': 'Curador alterado com sucesso',
  'Curator registered successfully': 'Curador cadastrado com sucesso',
  'A confirmation e-mail was sent to the registered e-mail address.':
    'Um e-mail de confirmação foi enviado para o e-mail cadastrado.',
  'Producer Registration': 'Cadastro de Produtor',
  'Judge Registration': 'Cadastro de Jurado',
  'New Producer': 'Novo Produtor',
  'New Judge': 'Novo Jurado',
  'Subscribe another product': 'Inscrever outro produto',
  'Register new product': 'Inscrever novo produto',
  'Edit Registration': 'Editar Inscrição',
  'Registration Detail': 'Detalhe da Inscrição',
  "Product's Name": 'Nome do Produto',
  'Certificate Type': 'Tipo de Certificação',
  'Municipal Certificate': 'Municipal',
  'State Certificate': 'Estadual',
  'Federal Certificate': 'Federal',
  'Selo Arte': 'Selo Arte',
  'Art Stamp': 'Selo Arte',
  "Products's Characteristics": 'Características do Produto',
  'Group': 'Grupo',
  'Origin': 'Origem',
  'Creation Date': 'Data de criação',
  'Update Date': 'Data de atualização',
  'Milk Type': 'Tipo de Leite',
  'Raw': 'Cru',
  'Pasteurized': 'Pasteurizado',
  'Manufacturing Date': 'Data de Fabricação',
  'Dough Treatment': 'Tratamento da Massa',
  'Registrations': 'Inscrições',
  'New Product Registration': 'Nova Inscrição de Produto',
  'Certificate': 'Certificado',
  'Code': 'Código',
  'Paid': 'Pago',
  'Products': 'Produtos',
  'Orders': 'Pedidos',
  'Orders History': 'Histórico de Pedidos',
  'Administrative': 'Administrativo',
  'Brazil': 'Brasil',
  'Italy': 'Itália',
  'United States': 'Estados Unidos',
  'France': 'França',
  'Germany': 'Alemanha',
  'Spain': 'Espanha',
  'Approved': 'Aprovado',
  'Failed': 'Reprovado',
  'Reprovado': 'Reprovado',
  'Pending': 'Pendente',
  'Occupation': 'Profissão',
  'of': 'de',
  'more than': 'mais que',
  'Proficiency Languages': 'Idiomas de Domínio',
  'Male': 'Masculino',
  'Female': 'Feminino',
  'Other': 'Outro',
  'Nationality': 'Nacionalidade',
  'Gender': 'Sexo',
  'Educational Background': 'Formação',
  'Professional Activity': 'Atividade Profissional',
  'Company': 'Empresa que Trabalha',
  'Add File': 'Adicionar Arquivo',
  'Delete': 'Excluir',
  'Are you sure that you want to delete': 'Tem certeza que deseja excluir o(a)',
  'Item deleted successfully!': 'Exclusão realizada com sucesso!',
  'Cart': 'Carrinho',
  'Description': 'Descrição',
  'Amount': 'Valor',
  'Go to payment': 'Ir para o pagamento',
  'Items': 'Itens',
  'Remove': 'Remover',
  'Order Summary': 'Resumo do Pedido',
  'Contest Parameters': 'Parâmetros do Concurso',
  'Payment Expiring Date': 'Prazo de Vencimento do Boleto',
  'Logout': 'Sair',
  'ID da Propriedade': 'ID da Propriedade',
  'Passaporte': 'Passaporte',
  'Approve': 'Aprovar',
  'Disapprove': 'Reprovar',
  'Invoices': 'Faturamento',
  'Order number': 'Número do pedido',
  'Order Number': 'Número do Pedido',
  'Order total': 'Total do pedido',
  'Cash Credit Card': 'Cartão de Crédito à vista',
  'Credit card in': 'Cartão de Crédito em',
  'installments': 'parcelas',
  'Credit Card': 'Cartão de Crédito',
  'Payment method': 'Forma de pagamento',
  'Payment Method': 'Forma de Pagamento',
  'YOUR NAME': 'SEU NOME',
  'Card Number': 'Número do Cartão',
  'Card Name': 'Nome do Cartão',
  'Valid Thru': 'Validade',
  'Installments': 'Parcelas',
  'Finish Order': 'Finalizar Pedido',
  'Finish Payment': 'Concluir Pagamento',
  'Válido até às': 'Válido até às',
  'Copy Pix Code': 'Copiar Código Pix',
  'Payment Info': 'Informações de pagamento',
  'Pix à vista': 'Pix à vista',
  'Boleto à vista': 'Boleto à vista',
  'Order': 'Pedido',
  'Payment Date': 'Data de Pagamento',
  'Vencida': 'Vencida',
  'Aguardando pagamento': 'Aguardando pagamento',
  'Expiring Date': 'Data de Vencimento',
  'Expired in': 'Vencida em',
  'Print': 'Imprimir',
  'Order Completed': 'Pedido Concluído',
  'Inscricao': 'Inscrição do Concurso',
  'Log In': 'Acessar',
  'Sign up': 'Novo usuário? Cadastre-se',
  'Remember me': 'Lembrar-me',
  'Change my password': 'Solicitar nova senha',
  'Back to login': 'Voltar para o Login',
  'Choose your role': 'Escolha o tipo de cadastro que deseja',
  'Paying Method': 'Forma de Pagamento',
  'CartaoCredito': 'Cartão de Crédito',
  'Order Details': 'Detalhe do Pedido',
  'Click on the link in this e-mail to validate your registration.':
    'Clique no link presente no e-mail para validar seu cadastro.',
  'Register': 'Cadastrar',
  'Successful Registration': 'Cadastro realizado com sucesso',
  'E-mail inválido': 'E-mail inválido',
  'Campo obrigatório': 'Campo obrigatório',
  'New Password': 'Nova Senha',
  'Password changed successfully': 'Senha alterada com sucesso!',
  'Change password': 'Alterar senha',
  'Delete file': 'Remover arquivo',
  'days': 'dias',
  'Product Information': 'Características do Produto',
  'Review Sheet': 'Ficha de Avaliação',
  'Review Sheets': 'Fichas de Avaliação',
  'Maturation Days': 'Dias de Maturação',
  "Product's Code": 'Código do Produto',
  'Estragado': 'Estragado',
  'Péssimo': 'Péssimo',
  'Ruim': 'Ruim',
  'Insuficiente': 'Insuficiente',
  'Razoável': 'Razoável',
  'Suficiente': 'Suficiente',
  'Bom': 'Bom',
  'Ótimo': 'Ótimo',
  'Excelente': 'Excelente',
  'Perfeito': 'Perfeito',
  'Send Review': 'Enviar Avaliação',
  'General Aspect': 'Aspecto Global',
  'Color': 'Cor',
  'Texture': 'Textura',
  'Odor': 'Odor',
  'Scent': 'Aroma',
  'Consistency': 'Consistência',
  'Flavor': 'Sabor',
  'Payment': 'Pagamento',
  'Title / Aspect': 'Título / Aspecto',
  'Title': 'Título',
  'Aspect': 'Aspecto',
  'Max Rating': 'Nota Máxima',
  'Weight': 'Peso',
  'Product': 'Produto',
  'Registration': 'Inscrição',
  'Cancel': 'Cancelar',
  'Add': 'Adicionar',
  'Ricotta': 'Ricota',
  'Requeijão em Barra': 'Requeijão em Barra',
  'Requeijão Moreno': 'Requeijão Moreno',
  'Fresco sem tratamento': 'Fresco sem tratamento',
  'Com Aquecimento': 'Com Aquecimento',
  'Sem Aquecimento': 'Sem Aquecimento',
  'Cru': 'Cru',
  'Pausterizado': 'Pausterizado',
  'Vaca': 'Vaca',
  'Cabra': 'Cabra',
  'Ovelha': 'Ovelha',
  'Búfala': 'Búfala',
  'Outro': 'Outro',
  'Event': 'Evento',
  'Awards Info': 'Informações do Concurso',
  'Contest Phase': 'Fase do Concurso',
  'Contest Phases': 'Fases do Concurso',
  'Max Grade': 'Nota Máxima',
  'Add question': 'Adicionar nova questão',
  'Contest Start Date': 'Dia de Início do Evento',
  'Contest': 'Concurso',
  'Payment Status': 'Pagamento',
  'Processando pagamento': 'Processando pagamento',
  'Não pago': 'Não pago',
  'Add phase': 'Adicionar fase',
  'Contest Phase Name': 'Nome da Fase do Concurso',
  'Contest Phase Order': 'Ordem da Fase do Concurso',
  'Phase Order': 'Ordenação da Fase',
  'Contest Tables': 'Mesas do Concurso',
  'Shuffle Tables': 'Sortear as mesas',
  'Table Details': 'Detalhes da Mesa',
  'Registrations by Producers': 'Inscrições por Produtor',
  'Your Reviews': 'Suas Avaliações',
  'New Curator': 'Novo Curador',
  'Curators': 'Curadores',
  'Edit Curator': 'Editar Curador',
  'Phone': 'Telefone',
  'Pending Payment': 'Pagamento Pendente',
  'Reports': 'Relatórios',
  'Table': 'Mesa',
  'Free': 'Isento',
  'Move': 'Mover',
  'Judge moved successfully': 'Jurado movido com sucesso!',
  'Product moved successfully': 'Produto movido com sucesso!',
  'Product reviewed successfully': 'Produto avaliado com sucesso!',
  'Return': 'Voltar',
  'Search': 'Buscar',
  'Filter': 'Filtro',
  'Table QR Codes': 'QR Codes das Mesas',
  "Print Judge's List": 'Imprimir Lista de Jurados',
  "Print Product's List": 'Imprimir Lista de Produtos',
  'Print QR Codes': 'Imprimir QR Codes',
  'Untie Priority': 'Prioridade no Desempate',
  'Real Time': 'Tempo Real',
  'Start Phase': 'Iniciar Fase',
  'End Phase': 'Finalizar Fase',
  'Average Score': 'Nota Média',
  'Reviews': 'Avaliações',
  'Total Reviews': 'Total de Avaliações',
  'Total Products': 'Total de Produtos',
  'Total Judges': 'Total de Jurados',
  'Reset Phase': 'Resetar Fase',
  'Average Score (%)': 'Nota Média (%)',
  'Winner (%)': 'Vencedor (%)',
  'Category Winner (%)': 'Vencedor da Categoria (%)',
  'Overall Awards Results': 'Classificação Geral',
  'Overall Result': 'Classificação Geral',
  'Category Result': 'Classificação na Categoria',
  'Score': 'Pontuação',
  'Export': 'Exportar para Excel',
  'Qualified by Phase': 'Classificados por Fase',
  'General': 'Geral',
  'Second Phase': 'Segunda Fase',
  'Refresh': 'Atualizar',
  'Selected': 'Selecionado',
  'Not selected': 'Não selecionado',
  'Deselect': 'Desselecionar',
  'Quantitative Assessment Form': 'Ficha de Avaliação Quantitativa',
  'Selecionados': 'Selecionados',
  'Select Judge': 'Selecionar Jurado',
  'Export Grades': 'Exportar com notas do concurso',
  'Reset Event': 'Resetar Evento',
  'Reopen Phase': 'Reabrir Fase',
  'Select a Category': 'Selecione uma categoria',
  'Please wait, exporting data...': 'Aguarde, exportando dados...',
  'Counting votes': 'Em apuração',
  'Heating': 'Aquecimento',
  'Heated': 'Com aquecimento',
  'No heated': 'Sem aquecimento',
  'Comment': 'Comentário',
  'Table Leader': 'Líder da Mesa',
  'Set Table Leader': 'Atribuir Líder da Mesa',
  'Table Leader Setup': 'Atribuição de Líder da Mesa',
  'Move Judge': 'Mover Jurado',
  'Details': 'Detalhes',
  'Warning': 'Atenção',
  'Change Table Leader': 'Alterar Líder da Mesa',
  'Scan QR Code': 'Escanear QR Code',
  'Loading': 'Carregando',
  'Product Status': 'Estado',
  'Shipped': 'Recebido',
  'Edit': 'Editar',
  'Unknown': 'Desconhecido',
  'Able': 'Apto',
  'Unable': 'Inapto',
  'Print Certificate': 'Imprimir Certificado',
  'Print Seal': 'Imprimir Selo',
  'Download Certificate': 'Baixar Certificado',
  'Contest Started': 'Concurso Iniciado',
  'Table Number': 'Número da Mesa',
  'Current Contest Phase': 'Fase do Concurso',
  "Table's Leader Veredic": 'Veredito do Líder da Mesa',
  'Grade': 'Nota',
  'Print Registration Form': 'Imprimir Ficha de Inscrição',
  'Page Not Found': 'Página Não Encontrada',
  'Print Review Report': 'Imprimir Relatório de Desempenho',
  'Reviews by Attributes': 'Avaliação por Atributo',
  'Move Product': 'Mover Produto',
  'Profession': 'Profissão',
  'Registered Products': 'Produtos Inscritos',
  'Registered products management': 'Gerenciamento de produtos inscritos no concurso',
  'New Registration': 'Nova Inscrição',
  'Active Contest': 'Concurso Vigente',
  'Edition': 'Edição',
  'Registration Fee:': 'Taxa de inscrição:',
  'Payment enabled': 'Pagamento habilitado',
  'No active contest at this time.': 'Nenhum concurso ativo neste momento.',
  'My Registration': 'Minha Inscrição',
  'Open': 'Aberta',
  'Registration date:': 'Data de inscrição:',
  'Registration Date': 'Data de Inscrição',
  'Total value:': 'Valor total:',
  "You haven't started your registration yet.": 'Você ainda não iniciou sua inscrição neste concurso.',
  'Starting...': 'Iniciando...',
  'Products Registrations': 'Produtos Inscritos',
  'Start Registration': 'Iniciar Inscrição',
  'My Registered Products': 'Meus Produtos Inscritos',
  'Register Product': 'Inscrever Produto',
  'Start your registration to add products.': 'Inicie sua inscrição para adicionar produtos.',
  'No products registered yet.': 'Nenhum produto inscrito ainda.',
  'Register first product': 'Inscrever primeiro produto',
  'Could not load registration data.': 'Não foi possível carregar os dados da inscrição.',
  'Error starting registration. Please try again.': 'Erro ao iniciar inscrição. Tente novamente.',
  'Product Detail': 'Detalhe do Produto',
  'Product Name': 'Nome do Produto',
  'Category / Group': 'Categoria / Grupo',
  'None': 'Nenhum',
  'Additional Information': 'Informações Adicionais',
  'Dates': 'Datas',
  'Registraded in': 'Cadastrado em',
  'Classification Answers': 'Respostas de Enquadramento',
  'Subcategory': 'Subcategoria',
  'Registered': 'Inscrito',
  'Error saving changes.': 'Erro ao salvar alterações.',
  'Could not load product data.': 'Não foi possível carregar os dados do produto.',
  'Product not found.': 'Produto não encontrado.',
  'cert.errCarregarPremiacao': 'Erro ao carregar informações de premiação.',
  'cert.semPremiacao': 'Este produto não possui premiação registrada.',
  'cert.selecionarFase': 'Selecionar fase',
  'cert.semTemplate': 'Nenhum template de certificado configurado para esta premiação.',
  'cert.gerando': 'Gerando...',
  'cert.errGerarCertificado': 'Erro ao gerar o certificado. Tente novamente.',
  'cert.comFundo': 'Imprimir com fundo',
  'cert.semFundo': 'Imprimir sem fundo',
  'Edit product data': 'Editar dados do produto',
  'No fields configured in the form of this subcategory.': 'Nenhum campo configurado no formulário desta subcategoria.',
  'Saving...': 'Salvando...',
  'Awarded Product': 'Produto Premiado',
  "Producer's Name": 'Nome do Produtor',
  'Product Registration': 'Inscrição de Produto',
  'User Profile Data': 'Dados do Usuário',
  'Authenticated user information': 'Informações do usuário autenticado',
  'Edit Profile': 'Editar Perfil',
  'Email': 'E-mail',
  'Global role': 'Papel global',
  'Role in contest': 'Papel no concurso',
  'Current Contest': 'Concurso Atual',
  'Year': 'Ano',
  'Closed': 'Encerradas',
  'Organization': 'Organização',
  'No active contest': 'Nenhum concurso ativo',
  'Judge Panel': 'Painel do Jurado',
  'My Tables': 'Minhas Mesas',
  'Judge Invite': 'Convite de Jurado',
  'Accept Invite': 'Aceitar Convite',
  'Decline': 'Recusar',
  'Back to my tables': 'Voltar às minhas mesas',
  'Back to table': 'Voltar à mesa',
  'No tables assigned yet': 'Você ainda não foi atribuído a uma mesa',
  'Your evaluation tables will appear here when assigned by the organizer.':
    'Suas mesas de avaliação aparecerão aqui quando o organizador fizer a atribuição.',
  'Overall evaluation progress': 'Progresso geral de avaliação',
  'evaluated': 'avaliados',
  'Evaluation progress': 'Progresso de avaliação',
  'All products evaluated in this table!': 'Todos os produtos avaliados nesta mesa!',
  'No products assigned to this table yet.': 'Nenhum produto atribuído a esta mesa ainda.',
  'Evaluation Form': 'Ficha de Avaliação',
  'Already evaluated — you can revise': 'Já avaliado — você pode revisar',
  'Scores': 'Pontuações',
  'Disqualify product': 'Desclassificar produto',
  'Disqualify': 'Desclassificar',
  'Cancel disqualification': 'Cancelar desclassificação',
  'Confirm disqualification': 'Confirmar desclassificação',
  'Reason for disqualification': 'Motivo da desclassificação',
  'Disqualification reason is required.': 'O motivo da desclassificação é obrigatório.',
  'Save evaluation': 'Salvar avaliação',
  'Evaluation saved!': 'Avaliação salva!',
  'Evaluated': 'Avaliado',
  'Score required': 'Pontuação obrigatória',
  'Error saving evaluation. Please try again.': 'Erro ao salvar a avaliação. Por favor, tente novamente.',
  'Could not load your tables. Please try again later.':
    'Não foi possível carregar suas mesas. Por favor, tente novamente mais tarde.',
  'Could not load table data. Please try again later.':
    'Não foi possível carregar os dados da mesa. Por favor, tente novamente mais tarde.',
  'Could not load evaluation form. Please try again later.':
    'Não foi possível carregar a ficha de avaliação. Por favor, tente novamente mais tarde.',
  'Contest Categories': 'Categorias do Concurso',
  'Add Category': 'Adicionar Categoria',
  'Categories': 'Categorias',
  'Category': 'Categoria',
  'Category Registration': 'Cadastro de Categoria',
  'New Category': 'Nova Categoria',
  'Edit Category': 'Editar Categoria',
  'Product Categories': 'Categorias de Produtos',
  'Search CEP': 'Buscar CEP',
  'Health Service Number': 'Número do Serviço Sanitário',
  'Health Certificate': 'Certificado Sanitário',
  'Duplicate': 'Duplicar',
  'Download Lab Analysis': 'Baixar Análise Laboratorial',
  'Download Curation': 'Baixar Curadoria',
  'Error downloading file': 'Erro ao baixar o arquivo',
  'Attach Analysis': 'Anexar Análise',
  'Receive': 'Receber',
  'Receive Product': 'Receber Produto',
  'Validate Product': 'Validar Produto',
  'Separate Product': 'Separar Produto',
  'In Analysis': 'Colocar em Análise',
  'Health Service': 'Serviço Sanitário',
  'Regional Innovation': 'Inovação Regional',
  'Lab Analyst': 'Analista Laboratorial',
  'Inspect Product': 'Inspecionar Produto',
  'Send to Analysis': 'Enviar para análise',
  'Send Product': 'Enviar produto',
  'Transfer Product': 'Transferir produto',
  'Receive Transfered Product': 'Receber Transferência de Produto',
  'Analysed': 'Analisado',
  'Terms of Service and Privacy Policy': 'Termos do Serviço e Política de Privacidade',
  'By continuing, you agree to the Terms of Service and Privacy Policy.':
    'Ao continuar com o cadastro, você concorda com os termos de serviço e com a nossa política de privacidade.',
  'I agree': 'Concordo',
  "I've read and agreed to the terms and privacy policy": 'Eu li e concordo com os termos e política de privacidade',
  'Profile': 'Perfil',
  'Themes': 'Temas',
  'View Analysis': 'Ver Análise',
  'Select All': 'Selecionar todos',
  'Question Order': 'Ordem',
  'New Review Sheet': 'Nova Ficha de Avaliação',
  'Edit Review Sheet': 'Editar Ficha de Avaliação',
  'Print Sample Submission Procedure': 'Imprimir Procedimento de Envio de Amostra',
  'Remarks': 'Observações',
  'Reset Password': 'Resetar Senha',
  'History': 'Histórico',
  'Attach Product Analysis': 'Anexar Análise do Produto',
  'Photographic Record': 'Registro Fotográfico',
  'View Record': 'Ver Registro',
  'Registrations closed': 'Inscrições encerradas',
  'Generate Certificates': 'Gerar Certificados',
  'First Position': 'Primeiros Colocados',
  'Second Position': 'Segundos Colocados',
  'Third Position': 'Terceiros Colocados',
  'Position Award': 'Posição de Premiação do Concurso',
  'Print Certificates': 'Imprimir Certificados',
  'Training': 'Treinamento',
  'Training Mode': 'Modo de Treinamento',
  'Scan the QR Code on the product label to start the evaluation.':
    'Escaneie o QR Code na etiqueta do produto para iniciar a avaliação.',
  'Training available': 'Treinamento disponível',
  'Start training': 'Iniciar treinamento',
  'Practice evaluation with a simulated list of products. Nothing is sent to the server.':
    'Treine a avaliação com produtos de teste. Suas notas não contam no concurso real.',
  'Training Table': 'Mesa de Treinamento',
  'Scan the QR code shown by the instructor or tap a product to open the form.':
    'Escaneie o QR Code projetado pelo instrutor ou toque em um produto para abrir a ficha.',
  'Simulated evaluation. Nothing is sent to the server.':
    'Esta é uma avaliação de treinamento — não conta no concurso real.',
  'Reset training? Local saved evaluations will be removed.':
    'Reiniciar o treinamento? Todas as suas notas de treinamento serão apagadas.',
  'Training product not found.': 'Produto de treinamento não encontrado.',
  'Back to training': 'Voltar ao treinamento',
  'Training evaluation saved on this device.': 'Avaliação de treinamento salva!',
  'Access as': 'Acessar como',
  'Choose a real user to impersonate. All actions persist as that user — be careful.':
    'Escolha um usuário real pra acessar como ele. Todas as ações ficam registradas em nome dele — use com cuidado.',
  'No active contest for this tenant.': 'Nenhum concurso vigente neste tenant.',
  'Could not load the active contest.': 'Não foi possível carregar o concurso vigente.',
  'Search by name or email…': 'Buscar por nome ou email…',
  'No results.': 'Sem resultados.',
  'Could not load the list. Try again.': 'Não foi possível carregar a lista. Tente novamente.',
  'Impersonate': 'Acessar como',
  'Showing the first 50 judges. Use search to filter.': 'Mostrando os primeiros 50 jurados. Use a busca pra filtrar.',
  'Showing the first 50 producers. Use search to filter.':
    'Mostrando os primeiros 50 produtores. Use a busca pra filtrar.',
  'Impersonating': 'Acessando como',
  'as Judge': '(Jurado)',
  'as Producer': '(Produtor)',
  'Exit impersonation': 'Sair',
  'Save training evaluation': 'Salvar avaliação',
  'Out of range': 'Fora do intervalo',
  'Disqualify this product': 'Desclassificar este produto',
  'Disqualification reason': 'Motivo da desclassificação',
  'Required': 'Obrigatório',
  'Total': 'Total',
  'Competition in Progress': 'Concurso em Andamento',
  'Good morning': 'Bom dia',
  'Good afternoon': 'Boa tarde',
  'Good evening': 'Boa noite',
  'Welcome to your judge panel': 'Bem-vindo ao seu painel de jurado',
  'Your next phase': 'Sua próxima fase',
  'You have {{n}} phases scheduled': 'Você tem {{n}} fases agendadas',
  '{{fase}} starts at {{date}}.': '{{fase}} começa em {{date}}.',
  "Check the schedule for what's coming up.": 'Veja na agenda o que vem por aí.',
  'Phase': 'Fase',
  'My schedule': 'Minha agenda',
  'Final score': 'Nota final',
  'Position': 'Posição',
  'Awarded': 'Premiado',
  'Disqualified': 'Desclassificado',
  'evaluations': 'avaliações',
  'Performance by attribute': 'Desempenho por atributo',
  'No attribute scores to display.': 'Sem notas por atributo pra mostrar.',
  'Detailed scores': 'Notas detalhadas',
  'Attribute': 'Atributo',
  'My score': 'Minha nota',
  'My product': 'Meu produto',
  'Group average': 'Média do grupo',
  'Comment from the table': 'Comentário da mesa',
  'Team recommendation': 'Recomendação da equipe',
  'Back': 'Voltar',
  'Waiting to start': 'Aguardando início',
  'In progress': 'Em andamento',
  'Counting': 'Em apuração',
  'Finalized': 'Finalizada',
  'Phase {{order}}': 'Fase {{order}}',
  'Expected for {{date}}': 'Previsto para {{date}}',
  'No date scheduled yet': 'Sem horário previsto ainda',
  'Started on {{date}}': 'Iniciada em {{date}}',
  'Table {{n}}': 'Mesa {{n}}',
  'Table not assigned yet': 'Aguardando a atribuição de mesa',
  "You're all set for {{concurso}}. We'll let you know as soon as you're assigned to a table.":
    'Tudo pronto para {{concurso}}. Avisaremos assim que você for atribuído a uma mesa.',
  "You're all set. We'll let you know as soon as you're assigned to a table.":
    'Tudo pronto. Avisaremos assim que você for atribuído a uma mesa.',
  'Wait for the organizer to draw the tables.': 'Aguarde o organizador realizar o sorteio das mesas.',
  'Once assigned, your tables will appear here automatically.':
    'Assim que o organizador fizer a atribuição, suas mesas aparecerão aqui automaticamente.',
  'On the day of the competition, scan the QR Code on each product to evaluate.':
    'No dia do concurso, escaneie o QR Code de cada produto para avaliar.',
  'Almost there!': 'Quase lá!',
  "The competition phase hasn't started yet — wait for the organizer to begin.":
    'A fase do concurso ainda não começou — aguarde o organizador iniciar.',
  "As soon as the phase starts, you'll be able to scan QR Codes to evaluate.":
    'Assim que a fase começar, você poderá escanear os QR Codes para avaliar.',
  'All caught up!': 'Tudo em dia!',
  "There's no active evaluation phase right now. See you in the next contest!":
    'Não há nenhuma fase de avaliação ativa no momento. Até o próximo concurso!',
  'Thank you for your participation': 'Obrigado por sua participação',
  'Your schedule has been completed.': 'Sua agenda já foi finalizada.',
  'My Judge Profile': 'Meus Dados de Jurado',
  'Your table': 'Sua mesa',
  'Lead Judge': 'Jurado Líder',
  "Point the camera at the product's QR Code. The evaluation form opens automatically when detected.":
    'Aponte a câmera para o QR Code do produto. A ficha de avaliação abre automaticamente ao detectar.',
  'Try again': 'Tentar de novo',
  'Enable camera': 'Ativar câmera',
  'Tap “Enable camera” to allow access. If nothing happens, check the camera permission for this site.':
    'Toque em “Ativar câmera” para permitir o acesso. Se nada acontecer, verifique a permissão de câmera deste site.',
  'Black image? Switch camera': 'Imagem preta? Trocar câmera',
  'Camera': 'Câmera',
  'The camera is being used by another app. Close it and try again.':
    'A câmera está sendo usada por outro app. Feche-o e tente de novo.',
  'No camera was found on this device.': 'Nenhuma câmera foi encontrada neste dispositivo.',
  'Could not start the camera. Check the permission and that no other app is using it.':
    'Não foi possível iniciar a câmera. Verifique a permissão e se nenhum outro app está usando.',
  'The camera only works over a secure connection (https).': 'A câmera só funciona em conexão segura (https).',
  'Camera access is blocked. Tap the lock/menu icon next to the address bar, open Permissions and allow the Camera, then reload the page.':
    'O acesso à câmera está bloqueado. Toque no ícone de cadeado/menu ao lado da barra de endereço, abra Permissões, permita a Câmera e recarregue a página.',
  'Product characteristics': 'Características do produto',
  'Comments': 'Comentários',
  'Comment is required for the lead judge.': 'Comentário é obrigatório para o jurado líder.',
  'General observations about the product...': 'Observações gerais sobre o produto...',
  "Lead judge feedback — register the table's consolidated impression about this product.":
    'Feedback do jurado líder — registre a impressão consolidada da mesa sobre este produto.',
  'characters': 'caracteres',
  'All evaluations done!': 'Tudo avaliado!',
  'You finished evaluating every product on your tables.': 'Você terminou de avaliar todos os produtos das suas mesas.',
  'Thank you for your work!': 'Obrigado pelo seu trabalho!',
  'You are evaluating as Lead Judge': 'Você está avaliando como Jurado Líder',
  'If you have any questions, please contact the organizer.': 'Em caso de dúvidas, entre em contato com o organizador.',
  'Completed': 'Concluída',
  'Progress': 'Progresso',
  'registration': 'inscrição',
  'Scan Product': 'Escanear Produto',
  'Table Code': 'Código de Mesa',
  'Curation': 'Curadoria',
  'Consultant Analysis': 'Análise do Consultor',
  'Download Award Seal': 'Baixar Selo de Premiação',
  // Compartilhar premiação nas redes
  'Share': 'Compartilhar',
  'Share your award': 'Compartilhe sua premiação',
  'Generating image...': 'Gerando imagem...',
  'Award image': 'Imagem da premiação',
  'Suggested text': 'Texto sugerido',
  'Copy text': 'Copiar texto',
  'Download image': 'Baixar imagem',
  'Share on LinkedIn': 'Compartilhar no LinkedIn',
  'Text copied': 'Texto copiado',
  'Could not copy the text': 'Não foi possível copiar o texto',
  'Could not open sharing. Download the image instead.': 'Não foi possível abrir o compartilhamento. Baixe a imagem.',
  'The award seal is not in a supported format (PNG, JPG, SVG or PDF), so it cannot be shared. Please contact the organizers.':
    'O selo da premiação não está num formato aceito (PNG, JPG, SVG ou PDF) e não pode ser compartilhado. Fale com a organização.',
  'Could not generate the image. Please try again.': 'Não foi possível gerar a imagem. Tente novamente.',
  'The organizer logo could not be loaded, so the image was generated without it.':
    'Não foi possível carregar o logo da organização; a imagem foi gerada sem ele.',
  'For Instagram, post the downloaded image from your phone and paste the copied text in the caption.':
    'Para o Instagram, publique a imagem baixada pelo celular e cole o texto copiado na legenda.',
  'My product {{produto}} won {{selo}} at {{concurso}} {{ano}}! {{hashtag}}':
    'Meu produto {{produto}} conquistou {{selo}} no {{concurso}} {{ano}}! {{hashtag}}',
  'Your Judge Certificate': 'Seu Certificado de Jurado',
  'Your certificate is ready': 'Seu certificado está disponível',
  'Download your certificate to print or save.': 'Baixe seu certificado para imprimir ou salvar.',
  'View Certificate': 'Ver Certificado',
  'Downloading...': 'Baixando...',
  'Could not download the certificate. Please try again later.':
    'Não foi possível baixar o certificado. Por favor, tente novamente mais tarde.',
  'Reviewed': 'Avaliado',
  'Download Consultant Analysis': 'Baixar Análise do Consultor',
  'Active Producers': 'Produtores Ativos',
  'Active Foreign Producers': 'Produtores estrangeiros ativos',
  'Approved Judges': 'Jurados aprovados',
  'Total registered judges': 'Total de jurados cadastrados',
  'Total registered users': 'Total de usuários cadastrados no sistema',
  'Total Registered Products': 'Total de Produtos Inscritos',
  'Received Products': 'Produtos Recebidos',
  'Products in Analysis': 'Produtos em Análise',
  'Products pending approval': 'Produtos pendentes para aprovação',
  'Approved Products': 'Produtos Aprovados',
  'Failed Products': 'Produtos Reprovados',
  'Products in Transit': 'Produtos em Trânsito',
  'Transfered Products': 'Produtos Transferidos',
  'Separated Products': 'Produtos Separados',
  'Total active producers': 'Total de Produtores Ativos',
  'Product Characteristics': 'Características do Produto',
  'Add Characteristic': 'Adicionar Característica',
  'Type': 'Tipo',
  'Ordering': 'Ordem',
  'Characteristics': 'Características',
  'Edit Characteristic': 'Editar Característica',
  'New Characteristic': 'Nova Característica',
  'Text': 'Texto',
  'Minimum Value': 'Valor Mínimo',
  'Maximum Value': 'Valor Máximo',
  'Value': 'Valor',
  'Active Category': 'Categoria Ativa',
  'Characteristic': 'Característica',
  'Next': 'Próximo',
  'Leite': 'Leite',
  'Tipo de Leite': 'Tipo de Leite',
  'Leite Cru': 'Leite Cru',
  'Leite Pasteurizado': 'Leite Pasteurizado',
  'Your cateogry is': 'Sua categoria é',
  'Reset': 'Reiniciar',
  'Values': 'Valores',
  'Change': 'Mudar',
  'Casca': 'Casca',
  'Tratamento da Massa': 'Tratamento da Massa',
  'Maturação': 'Maturação',
  'Leite de Vaca': 'Leite de Vaca',
  'Leite de Cabra': 'Leite de Cabra',
  'Leite de Ovelha': 'Leite de Ovelha',
  'Leite de Búfala': 'Leite de Búfala',
  'Maturado': 'Maturado',
  'Massa filada': 'Massa filada',
  'Massa não filada': 'Massa não filada',
  'Não se aplica': 'Não se aplica',
  'by': 'por',
  'Criado': 'Criado',
  'Pago': 'Pago',
  'Aprovado': 'Aprovado',
  'Avaliado': 'Avaliado',
  'Total Paid Products': 'Total de Produtos Pagos',
  'Reprocess': 'Reprocessar',
  'Confirms category duplication': 'Confirma a duplicação da categoria',
  'Available': 'Disponível',
  'Has counter evidence': 'Possui contra prova',
  'Add Selected Judges': 'Adicionar Juízes Selecionados',
  'Phase updated successfully': 'Fase atualizada com sucesso.',
  'Phase registred successfully': 'Fase cadastrada com sucesso.',
  'Repeat Judges': 'Repetir Juízes',
  'New Contest Phase': 'Nova Fase do Concurso',
  'Edit Contest Phase': 'Editar Fase do Concurso',
  'Add New Phase': 'Adicionar Nova Fase',
  'Started': 'Iniciado',
  'In Progress': 'Em Andamento',
  'Counting Votes': 'Em Apuração',
  'Number of Products': 'Qtd. de Produtos',
  'Coupons': 'Cupons',
  'Coupon': 'Cupom',
  'Discount Type': 'Tipo do Desconto',
  'Quantity': 'Quantidade',
  'Quantity Left': 'Quantidade Restante',
  'Start Date': 'Data Inicial',
  'End Date': 'Data Final',
  'Add Coupon': 'Adicionar Cupom',
  'New Coupon': 'Novo Cupom',
  'Porcentage': 'Porcentagem',
  'Money': 'Dinheiro',
  'Edit Coupon': 'Editar Cupom',
  'Milk coagulation day': 'Dia da coagulação do leite',
  'Discount': 'Desconto',
  'Total with Discounts': 'Total com Descontos',
  'Cupom inválido': 'Cupom inválido',
  'Apply Coupon': 'Aplicar Cupom',
  'Copied to clipboard': 'Copiado!',
  'Declassify Product': 'Desclassificar Produto',
  'Justification': 'Justificativa',
  'Product declassified successfully': 'Produto desclassificado com sucesso.',
  'Paid with coupon': 'Pagamento realizado com cupom',
  'Confirm Payment': 'Confirmar Pagamento',
  'All': 'Todos',
  'Expired': 'Vencida',
  'Awaiting Payment': 'Aguardando Pagamento',
  'Start Expiring Date': 'Data de Vencimento Inicial',
  'End Expiring Date': 'Data de Vencimento Final',
  'Finished': 'Finalizado',
  'Attach Photographic Record': 'Anexar Registro Fotográfico',
  'Award Phase': 'Fase Premiada',
  'Last Contest Phase': 'Última Fase do Concurso',
  'Not Started': 'Não Iniciado',
  'Qualified': 'Classificado',
  'Justification of Declassification': 'Justificativa da Desclassificação',
  'Shuffle Judges': 'Sortear Jurados',
  'Technical Advisor': 'Orientador Técnico',
  'Date of Birth': 'Data de Nascimento',
  'Address': 'Endereço',
  'Number': 'Número',
  'Complement': 'Complemento',
  'Neighborhood': 'Bairro',
  'Print by Podium': 'Imprimir por Podio',
  'Print All Certificates': 'Imprimir Todos os Certificados',
  'Reset Status': 'Voltar para o Estado Inicial',
  'Restrictions': 'Restrições',
  'Available Products': 'Produtos Disponíveis',
  'table': 'mesa',
  'Add Table': 'Adicionar Mesa',
  'Approval': 'Aprovação',
  'Generate PDF': 'Gerar PDF',
  'Access your account': 'Acesse sua conta',
  'Update': 'Atualizar',
  'Account': 'Conta',
  'Select Client': 'Selecione o Cliente',
  'wizard.back': 'Voltar',
  'wizard.continue': 'Continuar',
  'wizard.next': 'Pr\u00f3ximo',
  'wizard.steps.0': 'Dados da Conta',
  'wizard.steps.1': 'Escolher Concurso',
  'wizard.steps.2': 'Cadastro',
  'wizard.steps.3': 'Conclus\u00e3o',
  'wizard.step1.title': 'Configura\u00e7\u00f5es da conta',
  'wizard.step1.subtitle': 'Selecione seu idioma preferido e aceite os termos para continuar.',
  'wizard.step1.idiomaLabel': 'Idioma preferido',
  'wizard.step1.lgpd.title': 'Termos de Uso e Pol\u00edtica de Privacidade',
  'wizard.step1.lgpd.body':
    'Ao utilizar nosso sistema, voc\u00ea concorda com os termos de uso e pol\u00edtica de privacidade em conformidade com a <b>Lei n\u00ba 13.709/2018 (LGPD)</b>. Seus dados pessoais ser\u00e3o tratados exclusivamente para as finalidades descritas em nossa pol\u00edtica, incluindo o envio de comunica\u00e7\u00f5es, realiza\u00e7\u00e3o de contatos e pesquisas de interesse do organizador do concurso.',
  'wizard.step1.lgpd.link': 'Ver pol\u00edtica completa \u2197',
  'wizard.step1.lgpd.agree': 'Li e concordo com os <b>Termos de Uso</b> e a <b>Pol\u00edtica de Privacidade</b>',
  'wizard.step2.title': 'Escolha seu concurso',
  'wizard.step2.subtitle': 'Selecione o concurso no qual deseja se inscrever.',
  'wizard.step2.noConcursos':
    'Nenhum concurso com inscri\u00e7\u00f5es abertas no momento. Entre em contato com o organizador para mais informa\u00e7\u00f5es.',
  'wizard.step2.inscricoes': 'Inscri\u00e7\u00f5es',
  'wizard.step2.evento': 'Evento',
  'wizard.step2.gratuito': 'Gratuito',
  'wizard.step2.valor': 'Taxa de inscri\u00e7\u00e3o',
  'wizard.step3.title': 'Complete seu cadastro',
  'wizard.step3.subtitle': 'Preencha os dados abaixo para finalizar seu cadastro como produtor.',
  'wizard.step4.title': 'Cadastro conclu\u00eddo!',
  'wizard.step4.subtitle':
    'Seu cadastro em <b>{{nomeConcurso}}</b> foi finalizado com sucesso. Agora voc\u00ea pode inscrever seus produtos ou acessar o painel.',
  'wizard.step4.inscreverproduto': 'Inscrever primeiro produto',
  'wizard.step4.irpainel': 'Ir para o painel',
  'wizard.jurado.step2.label': 'Cadastro',
  'wizard.jurado.step2.title': 'Complete seu cadastro como jurado',
  'wizard.jurado.step2.subtitle': 'Preencha os dados abaixo para finalizar seu cadastro como jurado.',
  'wizard.jurado.step3.title': 'Cadastro concluído!',
  'wizard.jurado.step3.subtitle':
    'Seu cadastro como jurado foi finalizado com sucesso. Agora você pode acessar seu painel.',
  'wizard.jurado.step3.irpainel': 'Ir para o painel do jurado',
  'wizard.jurado.erroCarregarFormulario': 'Erro ao carregar o formulário de cadastro. Tente novamente.',
  'resultados.titulo': 'Resultados do Concurso',
  'resultados.todos': 'Todos os Grupos',
  'resultados.semConcursoAtivo': 'Nenhum concurso ativo encontrado.',
  'resultados.semResultados': 'Nenhum resultado publicado ainda.',
  'resultados.erroCarregar': 'Erro ao carregar os resultados. Tente novamente.',
  'resultados.produto.titulo': 'Resultado do Meu Produto',
  'resultados.produto.voltar': 'Voltar',
  'resultados.produto.naoEncontrado': 'Resultado não encontrado para este produto.',
  'resultados.produto.notasPorCriterio': 'Notas por Critério',
  'Contest Results': 'Resultados do Concurso',
  'Language preference not saved. Please try again.': 'Não foi possível salvar o idioma. Tente novamente.',
  // Curador
  'Curator': 'Curador',
  // Convite de Jurado
  'convite.titulo': 'Convite de Jurado',
  'convite.cabecalho': 'Você foi convidado para ser Jurado',
  'convite.descricao': 'Ao aceitar, você será direcionado para criar sua conta e acessar o concurso como jurado.',
  'convite.aceitar': 'Aceitar Convite',
  'convite.recusar': 'Recusar',
  'convite.confirmarRecusaTitulo': 'Recusar Convite',
  'convite.confirmarRecusaTexto':
    'Tem certeza que deseja recusar este convite de jurado? Esta ação não pode ser desfeita.',
  'convite.confirmarRecusa': 'Sim, recusar',
  'convite.voltar': 'Voltar',
  'convite.recusadoTitulo': 'Convite recusado.',
  'convite.recusadoSubtitulo': 'Você recusou o convite de jurado. Pode fechar esta página.',
  'convite.erroRecusar': 'Erro ao recusar o convite. Tente novamente.',
  // Inscrição de Produto
  'inscricao.nova.titulo': 'Inscrição de Produto',
  'inscricao.nova.tituloCurto': 'Nova Inscrição',
  'inscricao.nova.breadcrumb': 'Inscrições',
  'inscricao.nova.passo.classificacao': 'Classificação',
  'inscricao.nova.passo.dados': 'Dados do Produto',
  'inscricao.nova.secao.categorias': 'Categorias de produto',
  'inscricao.nova.secao.dados': 'Dados do produto',
  'inscricao.nova.campoObrigatorio': 'Campo obrigatório',
  'inscricao.nova.classificada.titulo': 'Produto cadastrado!',
  'inscricao.nova.refazer': 'Refazer',
  'inscricao.nova.wizard.erroCarga': 'Não foi possível iniciar a classificação.',
  'inscricao.nova.wizard.tentarNovamente': 'Tentar novamente',
  'inscricao.nova.wizard.semMatch.titulo': 'Nenhuma categoria encontrada',
  'inscricao.nova.wizard.refazerClassificacao': 'Refazer classificação',
  'inscricao.nova.wizard.multiplosResultados':
    'Encontramos mais de uma opção. Escolha a que melhor descreve seu produto:',
  'inscricao.nova.wizard.aguarde': 'Aguarde...',
  'inscricao.nova.wizard.avancar': 'Avançar',
  'inscricao.nova.wizard.etapa': 'Etapa',
  'inscricao.nova.wizard.certificado': 'Certificado',
  'inscricao.nova.direto.semGrupos': 'Nenhum grupo disponível para seleção direta neste concurso.',
  'inscricao.nova.direto.label': 'Selecione a categoria do produto',
  'inscricao.nova.direto.placeholder': 'Buscar por categoria, subcategoria ou grupo...',
  'inscricao.nova.direto.semOpcoes': 'Nenhum grupo encontrado',
  'inscricao.nova.tabs.wizard': 'Wizard (recomendado)',
  'inscricao.nova.tabs.direto': 'Escolha direta',
  'inscricao.nova.classificadoAlertPre': 'Produto classificado em',
  'inscricao.nova.classificadoAlertPos': 'Clique em',
  'inscricao.nova.classificadoAlertPos3': 'para continuar.',
  'inscricao.nova.categoriaSelecionada': 'Categoria Selecionada',
  'inscricao.nova.form.identificacao': 'Identificação',
  'inscricao.nova.form.nome': 'Nome do produto *',
  'inscricao.nova.form.nomeObrigatorio': 'O nome do produto é obrigatório',
  'inscricao.nova.form.nomePlaceholder': 'Ex.: nome que aparecerá no certificado',
  'inscricao.nova.form.caracteristicas': 'Características do produto',
  'inscricao.nova.form.camposObrigatorios': 'Preencha todos os campos obrigatórios marcados com *.',
  'inscricao.nova.acoes.cancelar': 'Cancelar',
  'inscricao.nova.acoes.voltar': 'Voltar',
  'inscricao.nova.acoes.proximaEtapa': 'Próxima etapa',
  'inscricao.nova.acoes.inscrevendo': 'Inscrevendo...',
  'inscricao.nova.acoes.inscrever': 'Inscrever Produto',
  'inscricao.nova.erroCarga': 'Não foi possível carregar as informações do concurso. Tente novamente.',
  'inscricao.nova.erroSubmit': 'Erro ao inscrever produto. Verifique os dados e tente novamente.',
  'inscricao.nova.feedback.sucesso': 'Produto inscrito com sucesso!',
  'inscricao.nova.feedback.verProdutos': 'Ver meus produtos',
  // Campos do formulário de produtor (por código)
  'campo.nome': 'Nome',
  'campo.nome_completo': 'Nome Completo',
  'campo.nome_fazenda': 'Nome da Fazenda / Queijaria',
  'campo.representante_legal': 'Representante Legal',
  'campo.cpf': 'CPF',
  'campo.cnpj': 'CNPJ',
  'campo.rg': 'RG',
  'campo.passaporte': 'Passaporte',
  'campo.tipo_documento': 'Tipo de Documento',
  'campo.email': 'E-mail',
  'campo.celular': 'Celular',
  'campo.telefone': 'Telefone Fixo',
  'campo.pais': 'País',
  'campo.cidade': 'Cidade',
  'campo.estado': 'Estado',
  'campo.cep': 'CEP',
  'campo.search_cep': 'Buscar CEP',
  'campo.endereco_logradouro': 'Logradouro',
  'campo.endereco_numero': 'Número',
  'campo.endereco_complemento': 'Complemento',
  'campo.endereco_bairro': 'Bairro',
  'campo.endereco_cidade': 'Cidade',
  'campo.endereco_uf': 'UF',
  'campo.website': 'Site',
  'campo.data_nascimento': 'Data de Nascimento',
  'campo.siapp': 'Número SIAPP',
  'campo.servico_sanitario': 'Certificado Sanitário',
  'campo.numero_servico_sanitario': 'Número do Serviço Sanitário',
  'campo.aceite_lgpd': 'Consentimento de Proteção de Dados',
  'campo.aceite_termos': 'Termos de Serviço',
  'campo.aceite_imagem': 'Autorização de Uso de Imagem',
  'My Producer Profile': 'Meu Perfil de Produtor',
  'Performance Report': 'Relatório de Desempenho',
  'Download PDF': 'Baixar PDF',
  'Generating...': 'Gerando...',
  'Judge opinion': 'Parecer',
  'Justify your scores — required in this phase.': 'Justifique suas notas — obrigatório nesta fase.',
  'Opinion is required in this phase.': 'O parecer é obrigatório nesta fase.',
  'Open file {{nome}}': 'Abrir {{nome}}',
  'Panel opinions': 'Pareceres da banca',
  // Avaliação remota: a mesa aparece pro jurado como "Banca"
  'Panel {{n}}': 'Banca {{n}}',
  'Voting until {{date}}': 'Votação até {{date}}',
  'Read more': 'Ler mais',
  'Read less': 'Ler menos',
  'Voting closed on {{date}}': 'Votação encerrada em {{date}}',
  'Panel not assigned yet': 'Banca ainda não atribuída',
  'Panel': 'Banca',
  'Your panel': 'Sua banca',
  'Back to my panels': 'Voltar às minhas bancas',
  'Back to panel': 'Voltar à banca',
  'All products evaluated in this panel!': 'Todos os produtos avaliados nesta banca!',
  'No products assigned to this panel yet.': 'Nenhum produto atribuído a esta banca ainda.',
  'As soon as the phase starts, the products to evaluate will appear here.':
    'Assim que a fase começar, os produtos para avaliar vão aparecer aqui.',
  'You finished evaluating every product on your panels.':
    'Você terminou de avaliar todos os produtos das suas bancas.',
  'Opinion {{n}}': 'Parecer {{n}}',
  'Click <b>New Registration</b> to register your first product.':
    'Clique em <b>Nova Inscrição</b> para cadastrar seu primeiro produto.',
  'this product': 'este produto',
  'This product has not been evaluated in any finalized phase yet.':
    'Este produto ainda não foi avaliado em nenhuma fase apurada.',
  'Reject': 'Reprovar',
  'Rejected': 'Reprovado',
  'Approve or reject this product.': 'Aprove ou reprove este produto.',
  'Choose Approve or Reject.': 'Escolha Aprovar ou Reprovar.',
  'Favorite': 'Favorito',
  'Mark as favorite': 'Marcar como favorito',
  'Remove from favorites': 'Tirar dos favoritos',
  'Choose up to {{k}} favorites among the products you evaluate. You can change your choice until the deadline.':
    'Escolha até {{k}} favoritos entre os produtos que você avalia. Dá para mudar a escolha até o prazo.',
  '{{n}} of {{k}} favorites chosen': '{{n}} de {{k}} favoritos escolhidos',
  'You have already chosen {{k}} favorites. Remove one to choose another.':
    'Você já escolheu {{k}} favoritos. Tire um para escolher outro.',
  'Save vote': 'Salvar voto',
  'Vote saved!': 'Voto salvo!',
  'Justify your vote — required in this phase.': 'Justifique seu voto — obrigatório nesta fase.',
  'Favorites chosen': 'Favoritos escolhidos',
  'Approval rate': '% de aprovação',
  'Votes': 'Votos',
  'votes': 'votos',
  'Popular vote': 'Voto popular',
  'Could not load the vote. Try again in a few minutes.':
    'Não foi possível carregar a votação. Tente de novo em alguns minutos.',
  'Voting starts on {{date}}': 'A votação começa em {{date}}',
  'Vote until {{date}}': 'Vote até {{date}}',
  'There is no popular vote in this contest right now.': 'Não há votação popular neste concurso no momento.',
  'Voting is closed. Thank you for taking part!': 'A votação está encerrada. Obrigado por participar!',
  'vote': 'voto',
  'You voted': 'Você votou',
  'Vote': 'Votar',
  'Something went wrong. Try again.': 'Algo deu errado. Tente de novo.',
  'Vote confirmed!': 'Voto confirmado!',
  'Vote for {{name}}': 'Votar em {{name}}',
  'I have read and accept the rules of the popular vote': 'Li e aceito o regulamento do voto popular',
  'Hide rules': 'Ocultar regulamento',
  'Read the rules': 'Ler o regulamento',
  'We sent a code to {{email}}. It is valid for 15 minutes — check your spam folder too.':
    'Enviamos um código para {{email}}. Ele vale por 15 minutos — confira também a caixa de spam.',
  'Resend code in {{s}}s': 'Reenviar código em {{s}}s',
  'Resend code': 'Reenviar código',
  'Change e-mail': 'Trocar e-mail',
  'Your vote for {{name}} was counted. Thank you!': 'Seu voto em {{name}} foi registrado. Obrigado!',
  'Send code': 'Enviar código',
  'Confirm vote': 'Confirmar voto',
  'Popular vote is open — vote for your favorite': 'O voto popular está aberto — vote no seu favorito',
  'Poor': 'Ruim',
  'Excellent': 'Ótimo',
  'Final score (jury + public)': 'Nota final (júri + público)',
  'Public {{nota}} (popular vote only)': 'Público {{nota}} (só voto popular)',
  'Jury {{juri}} × {{pj}}% + Public {{publico}} × {{pp}}%': 'Júri {{juri}} × {{pj}}% + Público {{publico}} × {{pp}}%',
  '{{n}} public vote': '{{n}} voto do público',
  '{{n}} public votes': '{{n}} votos do público',
  'Page not found': 'Página não encontrada',
  "Oops! This page didn't make the podium.": 'Ops! Essa página ficou fora do pódio.',
  'The address may have changed or the link is incomplete. How about going back and trying again?':
    'O endereço pode ter mudado ou o link está incompleto. Que tal voltar e tentar de novo?',
  'Go to the home page': 'Ir para o início',
  'Previous page': 'Página anterior',
  'Error 404': 'Erro 404',
  'Access closed': 'Acesso encerrado',
  'This platform is no longer available. For questions, please contact the organizer.': 'Esta plataforma não está mais disponível. Em caso de dúvidas, fale com a organização.',
  'In this vote you vote through the QR code available at each place.':
    'Nesta votação o voto é feito pelo QR code disponível em cada local.',
  'Your evaluation': 'Sua avaliação',
  'Your vote': 'Seu voto',
  'This candidate is not in a popular vote right now.': 'Este candidato não está em votação popular no momento.',
  'You have already voted for this candidate on this device.': 'Você já votou neste candidato por este aparelho.',
  'Choose up to {{k}} favorites in each category.': 'Escolha até {{k}} favoritos em cada categoria.',
  'Choose up to {{k}} favorites.': 'Escolha até {{k}} favoritos.',
  'Choose your favorite in each category.': 'Escolha seu favorito em cada categoria.',
  'Choose your favorite.': 'Escolha seu favorito.',
  'Rate each candidate you try — one evaluation per person for each candidate.':
    'Dê nota para cada candidato que você avaliar — uma avaliação por pessoa em cada candidato.',
  'Approve or reject each candidate — one evaluation per person for each candidate.':
    'Aprove ou reprove cada candidato — uma avaliação por pessoa em cada candidato.',
  'The limit renews every day.': 'O limite renova a cada dia.',
  'Each vote is confirmed by a code sent to your e-mail.':
    'Cada voto é confirmado por um código enviado ao seu e-mail.',
  'evaluation': 'avaliação',
  'approval': 'de aprovação',
  'Evaluate': 'Avaliar',
  'Evaluate {{name}}': 'Avaliar {{name}}',
  'We will send a 6-digit code to your e-mail to confirm the vote. Your data is used only to validate the vote.':
    'Vamos enviar um código de 6 dígitos para o seu e-mail para confirmar o voto. Seus dados são usados só para validar o voto.',
  'CPF (optional)': 'CPF (opcional)',
  'Continue': 'Continuar',
  'See all candidates': 'Ver todos os candidatos',
  // Visual novo (shell/auth no padrão do konq-backoffice)
  'Menu': 'Menu',
  'Contests': 'Concursos',
  'Judge invitation': 'Convite de Jurado',
  'Use the email {{email}} to create your account.': 'Use o e-mail {{email}} para criar sua conta.',
  'Pending approval': 'Aprovação pendente',
  'Your judge invitation is under review. You will be notified as soon as your participation is confirmed.':
    'Seu convite como jurado está sendo analisado. Você será notificado assim que sua participação for confirmada.',
  'products registered': 'produtos inscritos',
  'auth.tagline.title': 'Excelência que merece ser reconhecida',
  'auth.tagline.subtitle':
    'Inscreva seus produtos, acompanhe as avaliações e celebre suas conquistas — tudo em um só lugar.',
  'Download lab analysis report': 'Baixar laudo da análise laboratorial',
  'Until {{date}}': 'Até {{date}}',
  'termos.organizadorPadrao': 'o organizador do concurso',
  'termos.lgpd.tratamento':
    'Em observância à Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais — LGPD) e demais normas aplicáveis, autorizo, de forma livre, informada e inequívoca, que {{organizador}} realize o tratamento dos meus dados pessoais para as finalidades deste concurso: inscrição e avaliação dos produtos, comunicações sobre o concurso, atendimento de solicitações e pesquisas de interesse do organizador, bem como o uso da minha imagem e voz em fotos, documentos e outros meios de comunicação, para campanhas promocionais e institucionais.',
  'termos.lgpd.compartilhamento':
    'Ao me cadastrar, autorizo o compartilhamento dos resultados das análises laboratoriais e dos meus dados <b>APENAS</b> com os representantes de {{organizador}} que integram a comissão técnica do concurso, e declaro estar de acordo e cumprir todos os termos do regulamento.',
  'termos.imagem.titulo': 'Autorização de uso de imagem',
  'termos.imagem.aceitar': 'Estou de acordo',
  'termos.imagem.texto':
    'Eu, {{nome}}, portador(a) do RG nº {{rg}} e do CPF nº {{cpf}}, autorizo o uso da minha imagem e voz em ações de marketing, divulgação, mídias sociais e demais peças publicitárias que se fizerem necessárias, inclusive impressas ou por qualquer meio de divulgação, para uso exclusivo de {{organizador}} e por tempo indeterminado.',
  'landing.inscricoes': 'Inscrições',
  'landing.entrar': 'Entrar',
  'landing.cadastrar': 'Cadastrar',
  'landing.hero.titulo': 'Inscreva seu produto.<br/>Conquiste seu espaço.',
  'landing.inscricoesAbertas': 'Inscrições abertas',
  'landing.encerradas.titulo': 'Inscrições encerradas no momento',
  'landing.encerradas.texto': 'Acompanhe os próximos concursos entrando em contato com o organizador.',
  'landing.privacidade': 'Política de Privacidade',
  'landing.card.periodoInscricoes': 'Período para inscrições',
  'landing.card.dataEvento': 'Data do evento',
  'landing.card.taxa': 'Taxa de inscrição',
  'landing.card.gratuito': 'Gratuito',
  'landing.card.participar': 'Participar',
  'landing.hero.subtitulo':
    'Participe dos concursos disponíveis, cadastre seus produtos e acompanhe os resultados em tempo real.',
  'Ouro': 'Ouro',
  'Prata': 'Prata',
  'Bronze': 'Bronze',
  'resultados.produto.pontos': '{{nota}} pts',
  'resultados.produto.semCriterios': 'Nenhum critério disponível.',
  'resultados.produto.criterio': 'Critério',
  'resultados.produto.notaMedia': 'Nota média',
  'resultados.produto.maximo': 'Máximo',
  'resultados.produto.desempenho': 'Desempenho',
  'convite.naoEncontrado': 'Convite não encontrado.',
  'convite.expirado': 'Este convite expirou.',
  'convite.jaAceito': 'Este convite já foi aceito.',
  'convite.revogado': 'Este convite foi revogado.',
  'convite.erroBuscar': 'Não foi possível carregar o convite. Tente novamente.',
  'convite.carregando': 'Carregando convite...',
  'convite.invalido': 'Convite inválido',
  'convite.cabecalhoNomeado': '{{nome}}, você foi convidado para ser Jurado',
  'arquivo.erroUpload': 'Falha no upload do arquivo.',
  'arquivo.erroAbrir': 'Não foi possível abrir o arquivo.',
  'arquivo.enviando': 'Enviando...',
  'arquivo.substituir': 'Substituir arquivo',
  'arquivo.selecionar': 'Selecionar arquivo',
  'arquivo.ate': 'até {{mb}}MB',
  'arquivo.multiplos': 'múltiplos arquivos',
  'arquivo.um': '1 arquivo',
  'arquivo.abrir': 'Abrir',
  'arquivo.remover': 'Remover',
  'data.aPartirDe': 'Data deve ser a partir de {{date}}',
  'data.ateDia': 'Data deve ser até {{date}}',
  'data.invalida': 'Data inválida',
  'validacao.cnpjInvalido': 'CNPJ inválido',
  'validacao.cpfInvalido': 'CPF inválido',
  'validacao.cpfErroVerificar': 'Erro ao verificar CPF.',
  'validacao.erroSalvarCadastro': 'Erro ao salvar cadastro.',
  'validacao.camposFaltando': 'Campos obrigatórios não preenchidos: {{campos}}',
  // Pente fino de i18n (textos que estavam fixos no código)
  'erroFatal.titulo': 'Algo deu errado',
  'erroFatal.texto':
    'Encontramos um problema inesperado. O erro foi reportado automaticamente e nossa equipe está investigando.',
  'erroFatal.detalhes': 'Detalhes técnicos',
  'erroFatal.tentarNovamente': 'Tentar novamente',
  'erroFatal.recarregar': 'Recarregar a página',
  'semAcessoTenant.titulo': 'Sem acesso a este concurso',
  'semAcessoTenant.texto':
    'Sua conta não tem acesso ao concurso <b>{{slug}}</b>. Verifique se entrou com o e-mail correto, ou peça acesso ao organizador.',
  'validacao.cnpjJaCadastradoProdutor': 'CNPJ já cadastrado por outro produtor.',
  'validacao.cpfJaCadastradoProdutor': 'CPF já cadastrado por outro produtor.',
  'validacao.cadastroSalvo': 'Cadastro salvo com sucesso!',
  'validacao.linkInvalido.titulo': 'Link de cadastro inválido',
  'validacao.linkInvalido.texto': 'Acesse o link de cadastro fornecido pelo organizador do concurso para prosseguir.',
  'checkout.titulo': 'Pagamento da Inscrição',
  'checkout.passos.resumo': 'Resumo',
  'checkout.passos.cupom': 'Cupom',
  'checkout.passos.pagamento': 'Pagamento',
  'checkout.passos.confirmacao': 'Confirmação',
  'checkout.formas.pix': 'Pix',
  'checkout.formas.boleto': 'Boleto Bancário',
  'checkout.erroCarregar': 'Erro ao carregar dados da inscrição.',
  'checkout.cupomInvalido': 'Cupom inválido ou não aplicável.',
  'checkout.erroGerarFatura': 'Erro ao gerar fatura. Tente novamente.',
  'checkout.desabilitado': 'O pagamento não está habilitado para este concurso.',
  'checkout.resumoPedido': 'Resumo do Pedido',
  'checkout.taxaPorProduto': 'Taxa por produto',
  'checkout.produtosInscritos': 'Produtos inscritos',
  'checkout.total': 'Total',
  'checkout.cupomDesconto': 'Cupom de Desconto',
  'checkout.codigoCupom': 'Código do cupom',
  'checkout.aplicar': 'Aplicar',
  'checkout.descontoAplicado': 'Desconto de {{desconto}} aplicado! Novo total: {{total}}',
  'checkout.continuarComDesconto': 'Continuar com desconto',
  'checkout.pular': 'Pular',
  'checkout.formaPagamento': 'Forma de Pagamento',
  'checkout.selecione': 'Selecione',
  'checkout.subtotal': 'Subtotal',
  'checkout.descontoCupom': 'Desconto (cupom)',
  'checkout.totalAPagar': 'Total a pagar',
  'checkout.confirmarPagamento': 'Confirmar Pagamento',
  'checkout.pagamentoConfirmado': 'Pagamento Confirmado!',
  'checkout.pedido': 'Pedido: {{numero}}',
  'checkout.irParaInscricao': 'Ir para minha inscrição',
  'checkout.vencido': 'Pagamento vencido. Gere uma nova fatura.',
  'checkout.tentarNovamente': 'Tentar novamente',
  'checkout.aguardandoPagamento': 'Aguardando Pagamento',
  'checkout.pendente': 'Pendente',
  'checkout.pixCopiaECola': 'Pix Copia e Cola',
  'checkout.copiarPix': 'Copiar código Pix',
  'checkout.codigoBarras': 'Código de barras',
  'checkout.copiarCodigoBarras': 'Copiar código de barras',
  'checkout.abrirBoleto': 'Abrir Boleto',
  'Winner': 'Vencedor',
  'desempenho.fasesAvaliadas_one': '{{count}} fase avaliada',
  'desempenho.fasesAvaliadas_other': '{{count}} fases avaliadas',
  'desempenho.erroRelatorio': 'Não foi possível carregar o relatório de desempenho.',
  'desempenho.erroCarregar': 'Não foi possível carregar o desempenho.',
  'ficha.titulo': 'Ficha de Envio do Produto',
  'ficha.codigoProduto': 'Código do produto',
  'ficha.caracteristicas': 'Características do produto',
  'ficha.instrucoes.titulo': 'Instruções',
  'ficha.instrucoes.1': '1. Imprima esta ficha e cole-a de forma visível na embalagem do produto.',
  'ficha.instrucoes.2': '2. O código <b>{{codigo}}</b> é único e identifica esse produto durante todo o concurso.',
  'ficha.instrucoes.3':
    '3. O QR code permite ao operador localizar e atualizar este produto rapidamente em qualquer etapa.',
  'ficha.instrucoes.4': '4. Mantenha a ficha íntegra até o final da avaliação.',
  'ficha.rodape': 'Konq · Plataforma de Concursos',
  'ficha.umProduto': 'um produto',
  'ficha.preparando': 'Preparando ficha...',
  'Subcontest': 'Subconcurso',
  'Seal URL not found': 'Arquivo do selo não encontrado',
  'Error loading seal for printing': 'Erro ao carregar o selo',
  'Product description': 'Descrição do produto',
  'Loading...': 'Carregando...',
  'No transitions registered.': 'Nenhuma movimentação registrada.',
  'Download Seal': 'Baixar Selo',
  'Product name': 'Nome do produto',
  'Name is required': 'Nome é obrigatório',
  'Description is required': 'Descrição é obrigatória',
  'cert.baixar': 'Baixar certificado',
  'inscricao.nova.direto.variacao': 'Variação',
  'inscricao.nova.form.descricao': 'Descrição do produto',
  'inscricao.nova.form.descricaoObrigatoria': 'Descrição é obrigatória',
  'inscricao.nova.form.descricaoPlaceholder': 'Lote, informações adicionais...',
  'treinamento.produto': 'Produto de Treinamento {{n}}',
  'treinamento.categoria': 'Categoria de Treinamento',
  'treinamento.atributos.aparencia.nome': 'Aparência',
  'treinamento.atributos.aparencia.descricao': 'Avalie a aparência visual do produto.',
  'treinamento.atributos.aroma.nome': 'Aroma',
  'treinamento.atributos.aroma.descricao': 'Avalie o aroma característico.',
  'treinamento.atributos.sabor.nome': 'Sabor',
  'treinamento.atributos.sabor.descricao': 'Avalie o sabor predominante.',
  'treinamento.atributos.textura.nome': 'Textura',
  'treinamento.atributos.textura.descricao': 'Avalie a textura e consistência.',
  'treinamento.atributos.apresentacao.nome': 'Apresentação',
  'treinamento.atributos.apresentacao.descricao': 'Avalie a apresentação geral.',
  'resultados.semResultadosCategoria': 'Nenhum resultado publicado para esta categoria.',
  'resultados.produto.lugar': '{{posicao}}º lugar',
  'resultados.produto.deTotal': 'de {{total}}',
  'perfil.estado.conviteJuradoPendente': 'Convite de Jurado Pendente',
  'perfil.estado.produtorSemInscricao': 'Produtor (sem inscrição)',
  'erro.operacao': 'Erro ao executar a operação',
  'Produtor': 'Produtor',
  'Jurado': 'Jurado',
  'Curador': 'Curador',
  'Administrador': 'Administrador',
  'Viewing as {{nome}}: this profile is read-only.': 'Visualizando como {{nome}}: este perfil é somente leitura.',
  'cadastro.erroCarregarFormulario': 'Erro ao carregar o formulário de cadastro. Tente novamente.',
  'validacao.cnpjErroVerificar': 'Erro ao verificar CNPJ.',
  'My evaluations': 'Minhas Avaliações',
  'validacao.campoObrigatorio': 'Campo obrigatório',
};

export default pt;
